const indexItems = [
  { title: '台北娜娜专区', desc: '经典名场面 · 直播间精彩瞬间', icon: 'ri-user-star-line' },
  { title: '玩偶姐姐追踪', desc: '全网动态 · 实时更新', icon: 'ri-user-heart-line' },
  { title: '莫里秀合集', desc: '轻量版短视频 · 高能不断', icon: 'ri-vidicon-line' },
  { title: '直播翻车现场', desc: '网红翻车 · 笑点密集', icon: 'ri-emotion-laugh-line' },
  { title: '吃瓜短视频精选', desc: '热播内容 · 每日推荐', icon: 'ri-fire-line' },
  { title: '吃瓜娱乐快讯', desc: '行业动态 · 前线报道', icon: 'ri-flashlight-line' },
  { title: '搞笑吃瓜瞬间', desc: '名场面集锦 · 欢乐无限', icon: 'ri-emotion-happy-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950 text-center mb-3">
          主题索引
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          快速找到你感兴趣的吃瓜分类
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#"
              className="group flex items-start gap-4 p-5 bg-background-50 rounded-xl border border-background-200/80 hover:border-primary-200 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 flex-shrink-0 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-primary-600 text-lg`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
        {indexItems.length === 7 && (
          <div className="hidden lg:grid grid-cols-4 gap-4 md:gap-5 mt-4 md:mt-5">
            <div className="col-span-4 flex justify-center">
              <span className="text-xs text-foreground-400">共 {indexItems.length} 个分类，持续更新中</span>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}